<template>
  <div class="input-file__group-wrapper">
    <div class="input-file__group">
      <div class="input-file__item">
        <div class="input-file__progress">
          <div class="input-file__progress-line" style="width: 100%;"></div>
        </div>
        <div class="input-file__remove" v-if="removable" @click="$emit('remove')"></div>
        <a :href="link" target="_blank" @click="$emit('click')">
          <span class="input-file__name">{{name}}</span>
        </a>
        <span class="input-file__size" v-if="size">{{format.size}} {{$t(format.label)}}</span>
      </div>
      <span type="button" class="gui-btn-none-style" v-if="signed">
        <img class="accreditation__reg-img"
             src="@/assets/img/static/b-icon_edit.svg"
             @click="$emit('onsigncheck')">
      </span>
      <div v-if="time">
        <div class="input-file__actual-block">
          <div class="input-file__actual-img input-file__hidden">
            <img src="@/assets/img/static/clientarea-details.svg" alt="">
          </div>
          <div class="input-file__not-actual" v-if="datetime">
            <date-time :value="datetime" tag="span"></date-time>
          </div>
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Tooltip from './tooltip'
  import formattedSize from '@/libs/pretty-size'

  export default {
    props: {
      name: String,
      link: String,
      size: Number,
      removable: {
        type: Boolean,
        default: false
      },
      signed: {
        type: Boolean,
        default: false
      },

      time: {
        type: Number
      }
    },

    data: () => ({
      tooltip: {
        component: undefined,
        top: undefined,
        left: undefined
      }
    }),

    computed: {
      format() {
        return formattedSize(this.size);
      },

      datetime() {
        return this.time ? new Date(this.time) : undefined;
      }
    },

    methods: {
      showTooltip(event) {
        if (this.tooltip.component) return;

        const bounds = event.target.getBoundingClientRect();
        this.tooltip.top = bounds.top + window.scrollY;
        this.tooltip.left = bounds.left + window.scrollX + Math.trunc(bounds.width / 2);

        const tooltip = new Vue({
          ...Tooltip
        });

        tooltip.top = this.tooltip.top;
        tooltip.left = this.tooltip.left;

        this.tooltip.component = tooltip.$mount();
        document.body.appendChild(this.tooltip.component.$el);

        this.$emit('signCheck');
      },

      hideTooltip() {
        if (!this.tooltip.component) return;

        this.tooltip.component.$el.remove();
        this.tooltip.component.$destroy();
        this.tooltip.component = undefined;
      }
    }
  }
</script>

<style scoped>

</style>
